module.exports = __webpack_public_path__ + "img/stock2.b664a1ec.png";